import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  controlPanel: {
    display: 'flex',
    flexDirection: 'row',
  },
  overflowHidden: {
    overflow: 'hidden',
  },
}));

export default useStyles;
